import { gql } from '@apollo/client';

// Tool mutations of the analytics workspace: BOVW training, exports and
// bulk organization. All act on a single publication.

export const TRAIN_BOVW_MUTATION = gql`
  mutation TrainBovw($id: ID!, $clusters: Int) {
    trainBovw(input: { publicationId: $id, clusters: $clusters }) {
      success
      similarityCount
      error
    }
  }
`;

export const EXPORT_LITHICS_MUTATION = gql`
  mutation ExportLithics($id: ID!, $format: String, $points: Int) {
    exportLithics(input: { publicationId: $id, format: $format, numPoints: $points }) {
      filename
      contentType
      encoding
      content
    }
  }
`;

export const EXPORT_PUBLICATION_MUTATION = gql`
  mutation ExportPublication($id: ID!) {
    exportPublication(input: { publicationId: $id }) {
      filename
      contentType
      encoding
      content
    }
  }
`;

export const UPDATE_PUBLICATION_SITE_MUTATION = gql`
  mutation UpdatePublicationSite($id: ID!, $site: ID!) {
    updatePublicationSite(input: { publicationId: $id, siteId: $site }) {
      updatedCount
    }
  }
`;

export const UPDATE_PUBLICATION_GRAVE_TAGS_MUTATION = gql`
  mutation UpdatePublicationGraveTags($id: ID!, $tags: [ID!]) {
    updatePublicationGraveTags(input: { publicationId: $id, tagIds: $tags }) {
      updatedCount
    }
  }
`;

// ExportFile.content is base64 for binary payloads and utf-8 text otherwise.
export function downloadExportFile({ filename, contentType, encoding, content }) {
  let blob;
  if (encoding === 'base64') {
    const binary = atob(content);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
    blob = new Blob([bytes], { type: contentType });
  } else {
    blob = new Blob([content], { type: contentType });
  }
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
